import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { MccainContext } from 'screens/Integrations/MccainIntegration/context/Provider';
import PropertyIntegrationBase from 'screens/Integrations/components/PropertyIntegration';
import { INTEGRATIONS } from 'screens/Integrations/helpers/constants';
import MccainAuthentication from '../MccainAuthentication';
import MccainCropSeason from '../MccainCropSeason';
import MccainCropSeasonIntegration from '../MccainCropSeasonIntegration';
import MccainSummaryView from '../MccainSummaryView';
import McCainSuccessPage from '../McCainSuccessPage';

const STEPS = {
  1: <MccainAuthentication />,
  2: (
    <MccainCropSeasonIntegration>
      <MccainCropSeason />
    </MccainCropSeasonIntegration>
  ),
  3: <PropertyIntegrationBase integrationName={INTEGRATIONS.mccain} />,
  4: <MccainSummaryView />,
  5: <McCainSuccessPage />
};

const StepSelector = ({ fixedStep = undefined }) => {
  const {
    state: { step }
  } = useContext(MccainContext);

  return STEPS[fixedStep ?? step];
};

StepSelector.propTypes = {
  fixedStep: PropTypes.number
};

export default StepSelector;
